import {
  SearchCriteria,
  SearchItemOperator,
  SearchItemValue,
} from '@Types/api/common/filters';

export type Mapper = (
  key: string,
  value: SearchItemValue
) => [string, SearchItemValue];

const defaultMapper: Mapper = (key, value) => [key, value];

export const prepareSearchCriterias = (
  selectedFilters: Record<string, SearchItemValue>,
  filterTypes: Record<string, SearchItemOperator | SearchItemOperator[]>,
  mapper: Mapper = defaultMapper,
  exclusions: string[] = []
): SearchCriteria[] | undefined => {
  const output = Object.keys(selectedFilters)
    .filter((filterKey) => {
      const filterValue = selectedFilters[filterKey];

      const isEmptyStr = filterValue === '';
      const isEmptyArr = Array.isArray(filterValue) && !filterValue.length;
      const isNull = filterValue === null;
      const isExcluded = exclusions.includes(filterKey);

      if (isEmptyStr || isEmptyArr || isNull || isExcluded) {
        return false;
      }

      return true;
    })
    .reduce((acc, filterKey) => {
      const filterValue = selectedFilters[filterKey];
      const filterType = filterTypes[filterKey];

      const [resultKey, resultValue] = mapper(filterKey, filterValue);

      if (
        Array.isArray(filterType) &&
        filterType.length &&
        Array.isArray(resultValue) &&
        // specific for tender amount filter range
        Array.isArray(resultValue?.[0])
      ) {
        resultValue.forEach((elValue) => {
          const searchCriterias = (elValue as number[]).map((el, index) => ({
            name: resultKey,
            value: el,
            operator: filterType[index],
          }));
          acc.push(...searchCriterias);
        });

        return acc;
      }

      acc.push({
        name: resultKey,
        value: resultValue,
        operator: filterType as SearchItemOperator,
      });

      return acc;
    }, [] as SearchCriteria[]);

  if (!output.length) {
    return undefined;
  }

  return output;
};
